import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  root: {
    // height: "100vh",
  },
  title: { flexGrow: 1, color: "#fff", fontSize: 16, cursor: "pointer" },
  contents: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "960px",
    // minHeight: 1000,
    // marginTop: 100,
    // height: "calc(100% - 48px)",
  },
  // buttonList: {
  //   paddingTop: 24,
  //   paddingBottom: 24,
  //   "& button": {
  //     marginRight: 12,
  //     width: 120,
  //     paddingTop: 8,
  //     paddingBottom: 8,
  //   },
  //   // width: 200,
  // },
  // contentsChildren: {},
  // menuButton: {
  //   marginRight: theme.spacing(2),
  //   cursor: "pointer",
  //   fontSize: 16,
  // },
}));
const Layout = ({ children }) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.root}
      >
        <Grid
          container
          justify="center"
          alignItems="center"
          direction="column"
          className={classes.contents}
        >
          <Grid container justify="center" alignItems="center">
            {children}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Layout;
